<div id="rt_header" class="header bg-white header-fixed">
  <div class="container-fluid  align-items-stretch justify-content-between">
    <nav class="navbar navbar-expand-lg">
      <div class="search-bar">
        <h5><span>Hi</span> Admin,</h5>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ml-auto menu-icon">
          <li class="nav-item">
            @if (user.fullName) {
              <div class="dropdown">
                <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <div class="d-flex flex-row">
                    <div class="profile-content">
                      <h6>{{user.fullName}}</h6>
                      <p>Bhakts {{user.type}}</p>
                    </div>
                    <div class="profile-name"><h5>{{user.fullName.charAt(0)}}</h5></div>
                  </div>
                </button>
              </div>
            }
          </li>
          <!--          <li class="nav-item menu1"><a><i class="las la-bell"></i></a><span class="badge badge-light">2</span></li>-->
          <li class="nav-item menu1"><a (click)="logout()">Logout<i class="fa fa-sign-out ml-2" aria-hidden="true"></i></a></li>
        </ul>
      </div>
    </nav>
  </div>
</div>
